import { Box, Button, Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';
import NavLink from './NavLink';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function GroupedMenu({
    groupedItems = [],
    label = "menu",
    handlePathDirection
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const timeoutRef = useRef(null);
    const containerRef = useRef(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => {
        handleMouseEnter();
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setAnchorEl(null);
        }, 500);
    };

    return (
        <Box
            ref={containerRef}
            onMouseEnter={(e) => handleOpen(e)}
            onMouseLeave={handleMouseLeave}
            sx={{ display: 'inline-block', position: 'relative' }}
        >
            <Button
                onClick={handleOpen}
                sx={{ fontWeight: 'bold' }}
                color="white"
                variant="text"
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
                {label}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave,
                }}
                disableAutoFocusItem
                sx={{ mt: 1 }}
            >
                {groupedItems.map((item, index) => (
                    <MenuItem key={index} sx={{ p: 0 }}>
                        <NavLink path={item} primaryColor handlePathDirection={handlePathDirection} />
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
}
